import styled from "styled-components";
import { media } from "../../theme/theme";
import { MarketingSpacing } from "../ReusableStyledComponents/MarketingSpacing";
import { Body, H2, H4, V3Body, V3Title } from "../Typography";

export const MarketingFAQWrapper = styled.div`
    max-width: 1369px;
    margin: 0 auto;
    position: relative;

    @media print {
        display: none;
    }
`;

export const FAQSVG = styled.img`
    display: none;

    ${media.tablet} {
        position: absolute;
        width: 100%;
        height: auto;
        display: block;
        z-index: -1;
    }
`;

export const QuestionsWrapper = styled.div`
    width: 100%;
    max-width: 623px;
    margin: 0 auto;
    ${MarketingSpacing}

    ${H2} {
        margin-bottom: 35px;

        ${media.phone} {
            margin-bottom: 76px;
        }
    }

    ${V3Title} {
        margin-bottom: 35px;
    }
`;

export const QuestionWrapper = styled.div<{ open: boolean, useV3Components: boolean }>`
    padding: ${({ useV3Components }) => useV3Components ? "20px 0 0 0" : "45px 0 0 0"};
    border-bottom: 1px solid #E4EDFF;

    &:hover {
        cursor: pointer;
    }

    > ${V3Body},
    ${Body} {
        color: ${({ theme }) => theme ? theme.marketing.colors.blackPearl80 : null};
        max-height:  ${({ open }) => open ? "400px" : "0px"};
        overflow: hidden;
        transition: max-height .3s ease, padding-bottom .3s ease;
        margin-top: ${({ useV3Components }) => useV3Components ? "20px" : "45px"};
        padding-bottom:  ${({ open }) => open ? "45px" : "0px"};
    }

    svg {
        transform: ${({ open }) => open ? "rotate(180deg)" : "rotate(0)"};
        transition: transform .4s ease;
    }
`;

export const QuestionSVG = styled.div<{ useV3Components: boolean }>`
    display: flex;
    align-items: center;
    justify-content: ${({ useV3Components }) => useV3Components ? "space-between" : undefined};

    ${H4} {
        margin-right: 10px;
    }
`;


export const FAQTitle = styled(H2)`
    font-size: ${({ theme }) => theme ? `${theme.marketing.typography.size.s5}px` : null};
    line-height: ${({ theme }) => theme ? `${theme.marketing.typography.lineHeight.l7}px` : null};

    ${media.tablet} {
        font-size: ${({ theme }) => theme ? `${theme.marketing.typography.size.s2}px` : null};
        line-height: ${({ theme }) => theme ? `${theme.marketing.typography.lineHeight.l2}px` : null};
    }
`;

export const FAQQuestionTitle = styled(H4)`
    font-size:  20px;

    ${media.tablet} {
        font-size: ${({ theme }) => theme ? `${theme.marketing.typography.size.s6}px` : null};
        line-height: ${({ theme }) => theme ? `${theme.marketing.typography.lineHeight.l6}px` : null};
    }
`;